function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.965 17c-.246 1.725-1.723 3.006-3.465 3.006-1.742 0-3.22-1.281-3.465-3.006H1V5c0-.552.448-1 1-1h14c.552 0 1 .448 1 1v2h3l3 4.056V17h-2.035c-.246 1.725-1.723 3.006-3.465 3.006-1.742 0-3.22-1.281-3.465-3.006h-5.07zM15 6H3v8.05c.8-.818 1.95-1.192 3.08-1.003 1.128.19 2.093.919 2.583 1.953h5.674c.168-.353.393-.674.663-.95V6zm2 6h4v-.285L18.992 9H17v3zm.5 6c.829 0 1.5-.672 1.5-1.5 0-.83-.671-1.501-1.5-1.501s-1.5.672-1.5 1.5c0 .83.671 1.501 1.5 1.501zM7 16.5c0-.536-.286-1.031-.75-1.299s-1.036-.268-1.5 0c-.464.268-.75.763-.75 1.299 0 .828.672 1.5 1.5 1.5S7 17.328 7 16.5z"
});

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0H22V16H0z",
  transform: "translate(1 4)"
})));

function SvgIconSpaceVehicle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSpaceVehicle);
export default __webpack_public_path__ + "static/media/icon-spaceVehicle.992d3617.svg";
export { ForwardRef as ReactComponent };